import React from "react";
import { Box, Skeleton, Card, CardContent, styled } from "@mui/material";

const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  borderBottom: 'none',
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  width: '100%',
  backgroundColor: theme.palette.background.paper,
}))

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  "&:last-child": {
    paddingBottom: theme.spacing(2),
  },
}))

const HeaderRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing(1),
}))

const ContentRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
}))

const TextContent = styled(Box)({
  flex: 1,
  minWidth: 0,
})

// const FooterRow = styled(Box)(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   marginTop: theme.spacing(1),
// }))


export const CommunicationSkeleton: React.FC = () => {
  return (
    <StyledCard>
      <StyledCardContent>
        <HeaderRow>
          <Box display="flex" alignItems="center" gap={1}>
            <Skeleton variant="circular" width={8} height={8} />
            <Skeleton variant="text" width={80} height={16} />
          </Box>
        </HeaderRow>

        <ContentRow>
          <Skeleton variant="circular" width={40} height={40} />

          <TextContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
            <Skeleton variant="text" width="60%" height={20} sx={{ mb: 0.5, fontSize: "1rem" }} />
            <Skeleton variant="text" width="15%" height={16} />

          </Box>
            <Skeleton variant="text" width="80%" height={16} sx={{ mb: 1, fontSize: "0.875rem" }} />
            {/* <Skeleton variant="text" width="100%" height={16} sx={{ mb: 0.5, fontSize: "0.875rem" }} /> */}
            {/* <Skeleton variant="text" width="70%" height={16} sx={{ fontSize: "0.875rem" }} /> */}
          </TextContent>
        </ContentRow>

      </StyledCardContent>
    </StyledCard>
  )
}

export default CommunicationSkeleton; 